import type { ReactNode } from "react";

import clsx from "clsx";

import type { Availabilities } from "@/src/domain/model/Availability";
import type { ProductReference } from "@/src/domain/model/Product";

import { askForProducts } from "@/src/app/externalLinks";
import { pathToProduct } from "@/src/app/paths";
import { ButtonLink } from "@/src/components/ui/Button/ButtonLink";
import { ItemsAvailability } from "@/src/components/ui/ItemsAvailability";
import { ModalContent } from "@/src/components/ui/Modal/ModalContent";
import { sortedAvailabilities } from "@/src/domain/model/Availability";

export interface MerchantModalProps {
  readonly name: string;
  readonly products: Availabilities<ProductReference>;
  readonly url?: string;
}

export function MerchantModal({
  name,
  products,
  url,
}: MerchantModalProps): ReactNode {
  return (
    <ModalContent
      aside={
        <ButtonLink
          className={clsx("block w-full", "after:ml-1 after:content-['☝️']")}
          href={askForProducts.href}
          size="big"
        >
          Demander l’arrivée des produits
        </ButtonLink>
      }
      description={
        products.count > 1
          ? `${products.count} produits référencés`
          : `${products.count} produit référencé`
      }
      title={name}
      url={url ?? null}
    >
      {sortedAvailabilities.map((availability) => (
        <ItemsAvailability
          availability={availability}
          items={products.availabilities[availability].map((product) => ({
            href: pathToProduct(product),
            id: product.id,
            image: product.packImage,
            name: product.name,
          }))}
          key={availability}
        />
      ))}
    </ModalContent>
  );
}
